import { Component, OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { Publication } from '../../interfaces/publications/interfaces';
import { PublicationsService } from '../../services/publications.service';
import { StorageService } from '../../storage.service';

@Component({
  selector: 'app-publications',
  templateUrl: './publications.component.html',
  styleUrls: ['./publications.component.sass']
})
export class PublicationsComponent implements OnInit, OnDestroy {

  public publications: Publication[] = [];
  public publicationsCount = 0;
  public publishedPublicationsIds = [];
  public newPublications = false;
  public clickCount = 0;
  public publicationSubsctiprion: Subscription;
  public currentUser = this._storageService.getCurrentUser();
  public localSeenPublications = [];
  public showPublications = '';
  @ViewChild('dropdownPublications') dropdownPublications: ElementRef;
  constructor(
    private _publicationsService: PublicationsService,
    private router: Router,
    private _storageService: StorageService,

  ) { }


  ngOnInit() {
    this.getLocalSeen(this.currentUser.user_id);
    this.getPublications();
    this.publicationSubsctiprion = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.newPublications = false;
        this.getLocalSeen(this.currentUser.user_id);
        this.getPublications();
      }
    });
  }

  ngOnDestroy() {
    this.publicationSubsctiprion.unsubscribe();
  }

  checkFirstTime() {
    if (this.localSeenPublications.length === 0) {
      setTimeout(() => {
        if (this.dropdownPublications) {
          this.triggerClick();
        }
      }, 100);
    }
  }

  triggerClick() {
    if (this.dropdownPublications) {
      const dropdownTrigger: HTMLElement = this.dropdownPublications.nativeElement;
      dropdownTrigger.click();
    }
  }

  getPublications() {   // Trae las publicaciones vigentes
    this._publicationsService.getPublications()
      .subscribe(publications => {
        publications.splice(4);
        if (publications.length > 0) {
          this.publications = publications;
          this.publicationsCount = publications.length;
          this.publishedPublicationsIds = this.publications.map(publication => {
            return publication.id;
          });
          this.newPublicationsCheck(this.publishedPublicationsIds);
        }
      });
  }
  saveSeen() {
    const seenPublications = this.publications.map(publication => {
      return publication.id.toString();
    });
    const dataLog = { id: seenPublications };
    // guardar el log de visualizacion de publicacion
    if (document.getElementById('dropMenuContainerPublications').className.search('show') === -1) {
      this._publicationsService.logView(dataLog).subscribe();
    }
    this.clickCount++;
    this._storageService.setCookie(this.currentUser.user_id.toString(), JSON.stringify(seenPublications));

  }
  getLocalSeen(userID) {
    if (this._storageService.getCookie(userID).length > 0) {
      this.localSeenPublications = JSON.parse(this._storageService.getCookie(userID));
    }

  }
  saveClick(publicationId) {
    this._publicationsService.logClick(publicationId).subscribe();
  }

  viewedPublication(id) {
    return this.localSeenPublications.includes(id.toString());
  }

  newPublicationsCheck(publicationsIds) {

    publicationsIds.forEach(publicationId => {
      if (this.localSeenPublications.indexOf(publicationId.toString()) === -1) {
        this.newPublications = true;
      }
    });

    if (this.newPublications) {
      this.checkFirstTime();
      this.clickCount = 0;
    }

  }

}



// WEBPACK FOOTER //
// ./src/app/layout/publications/publications.component.ts